export class CommRate {


}

export module IBrokerageRelated {
  export enum FeeStatus {
    NOT_APPLICABLE = "NOT_APPLICABLE",
    FEE_AGREED = "FEE_AGREED",
    FEE_REJECTED = "FEE_REJECTED"
  }
}
